module.exports = parcelRequire.resolve("gxB9R");